import React from 'react';
import styled from 'styled-components';

export default function GroupBottom(props) {
    return(
        <Btmtext position={props.position}>
            <Text onClick={()=>{props.updateNext(1)}}>{props.text}</Text>
        </Btmtext>
    );
}


const Btmtext = styled.div`
    position: ${props=> props.position};
    bottom:0;
    left:0;
    width: 100%;
    height: calc(100vw*(56/375));
    background-color: #ffcf19;
    font-size: calc(100vw*(16/375));
    line-height: calc(100vw*(56/375));
    letter-spacing: 0.25px;
    text-align: center;
    color: #4e4e4e;
`
const Text = styled.h1`
    font-weight: bold;
`

